import { Injectable } from '@angular/core';
import { Gender } from '../models/new/style';

@Injectable({
	providedIn: 'root'
})
export class GenderMapper {
	constructor() {}

	toGender(gender: any) {
		return new Gender({
			id: gender.id,
			name: gender.name
		});
	}
}
